import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import PrivacyPolicy from "./PrivacyPolicy";
import { ScrollRestoration } from "react-router-dom";
import { BASE_URL } from "../Config";

function PrivacyPolicyMain() {
  return (
    <div>
      {/*Add title and metadata */}
      <title>Terms Of Service - Shiva PDF</title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href={`${BASE_URL}/terms_of_service`} />
      <meta
        name="description"
        content="All in one PDF manager and image editing tools. Edit, convert, compress, merge PDFs and enhance images easily with our fast, secure online tools."
      ></meta>

      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Nav Bar */}
      <NavBar />
      {/* privacy policy */}
      <PrivacyPolicy />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PrivacyPolicyMain;
